import { getRangeByKeys } from '../../ui-kit/Calculator/rangeHelpers.js';
import { clamp } from '../../utils/clamp.js';
import { isRubles } from './isRubles.js';
export const normalizeMonthValue = (_, rows) => {
    const { minMonths, maxMonths } = getRangeByKeys(['minMonths', 'maxMonths'], getRows(rows, _?.currency));
    const monthsValue = _.monthsValue || Math.round((minMonths + maxMonths) / 2);
    return { monthsValue: clamp(monthsValue, minMonths, maxMonths) };
};
export const normalizeMoneyValue = (_, rows) => {
    const { minSum, maxSum } = getRangeByKeys(['minSum', 'maxSum'], getRows(rows, _?.currency));
    const moneyValue = _.moneyValue || minSum;
    return { moneyValue: clamp(moneyValue, minSum, maxSum) };
};
export const normalizeCurrency = (_, rows) => ({
    currency: _?.currency ?? rows?.map((row) => row.currency)?.[0],
});
export const normalizeReplenishWithdrawn = (_) => {
    const _isRubles = isRubles(_?.currency?.key);
    return { isReplenish: _isRubles && _?.isReplenish, isWithdrawn: _isRubles && _?.isWithdrawn };
};
export const getRows = (rows, currencyValue) => {
    const { rates } = rows?.find((_) => _?.currency.key === currencyValue?.key) ?? {};
    return rates ?? rows?.[0]?.rates;
};
//# sourceMappingURL=utils.js.map